const AllGames = [
    {
        id: 0,
        device: "Mobile",
        tech: "HTML5",
        gWidth: 800,
        gHeight: 480,
        Name: "Back to School",
        gamelink: "https://www.jmkit.com/games/jmkitplaysets_backtoschool__GA_1_6/index.html",
        Thumb: "https://www.jmkit.com/images/gamethumbs/playsets/backtoschool_thumb.png",
        gAbout: "Take the JMKit Characters Back To Blissville HighSchool in the BackToSchool PlaySets game! With multiple Classrooms, The Hallway, a Gym, Pool Canteen and Principles office, you'll have plenty of areas to tell your school ground tales!",
        gTags: [
            "Playsets", "Creative", "Storytelling", "Make-a-scene", "Html5"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Bagle", "Pepper", "Pixie", "Lola", "Jasper", "Missel", "Appa", "Molly", "Tumble", "Chips", "Trott", "Lumi", "Flake", "Bleu", "Lil", "Debra", "Chloe", "Dex", "Boo"
        ],
        urlName: "backtoschool",
        prevURL: "jmkit.com/playsets/school/",
    },
    {
        id: 1,
        device: "Mobile",
        tech: "HTML5",
        gWidth: 800,
        gHeight: 480,
        Name: "My Home Makeover",
        gamelink: "https://www.jmkit.com/games/jmkitplaysets_homemakeover_GA_1_9/index.html",
        Thumb: "https://www.jmkit.com/images/gamethumbs/playsets/homemakeover_thumb.png",
        gAbout: `JMKit PlaySets My House Makeover is a digital doll house where you can decorate your own house and create your own stories with a collection of cute and cool characters! Ever thought 'I want to design my own house' well now you can design your house your way in the launch PlaySets game! The house is only the begining! Check back to JMKit regularly for updates to this game, and to see the expanding PlaySets World!`,
        gTags: [
            "Playsets", "Creative", "Storytelling", "Make-a-scene", "Html5"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Bagle", "Pepper", "Pixie", "Lola", "Jasper", "Missel", "Appa", "Molly", "Tumble", "Chips", "Trott", "Lumi", "Flake", "Bleu", "Lil", "Debra", "Chloe", "Dex", "Boo"
        ],
        urlName: "myhomemakeover",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 2,
        device: "Desktop",
        tech: "AS3",
        gWidth: 740,
        gHeight: 440,
        Name: "JMKit PlaySets",
        gamelink: "https://www.jmkit.com/playsets/gamefiles/PlaySets_7718.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/playsets/flashplaysets_thumb.png",
        gAbout: `In JMKit Play-Sets you can create your own scenes and stories with the cute and cool JMKit characters! Set your stories in a number of houses not to mention a school, hospital, airport, pet store, café’s, in the town, on a train, on a plane, in the jungle in the desert or underwater.. Discover all the places to play in JMKit PlaySets`,
        gTags: [
            "Playsets", "Creative", "Storytelling", "Make-a-scene"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Bagle", "Pepper", "Pixie", "Lola", "Jasper", "Missel", "Molly", "Tumble", "Chips", "Trott", "Lumi", "Flake", "Bleu", "Lil", "Debra", "Chloe", "Dex", "Boo"
        ],
        urlName: "jmkitplaysets",
        prevURL: "https://www.jmkit.com/playsets/school/",

    },
    {
        id: 3,
        device: "Mobile",
        tech: "HTML5",
        gWidth: 800,
        gHeight: 480,
        Name: "My Pony Surprise Party",
        gamelink: "https://www.jmkit.com/duh_l/MLPBirthdaySurprise/index.html",
        Thumb: "https://www.jmkit.com/images/gamethumbs/myponyparty.jpg",
        gAbout: `It's Rarity's birthday in this totally unofficial MLP game!
        Her other ponies want to throw the perfect surprise party so they'll each play their part and you can help them! Guide Pinkie Pie from cloud to cloud collecting Ice Creams.
        Help Apple Jack buck apple trees to collect applies for some delicious pies.
        Use the arrow keys to Point Fluttershy in the right direction to gather together some woodland animal friends. Join Rarity to help choose the perfect outfit for Twilight.
        Then to avoid the whole party getting rained off, it's Rainbowdash to the rescue, tap the clouds to clear the sky!`,
        gTags: [
            "MLP", "Mini-Games", "Html5"
        ],
        gCharacters: [
            "Ponies"
        ],
        urlName: "myponysurpriseparty",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 4,
        device: "Mobile",
        tech: "HTML5",
        gWidth: 800,
        gHeight: 480,
        Name: "Princess Guitar Dreams",
        gamelink: "https://www.jmkit.com/duh/TheIcePrincessGuitarDreams/index.html",
        Thumb: "https://www.jmkit.com/images/gamethumbs/guitardreams.jpg",
        gAbout: `This Ice Princess has always dreamed about playing guitar, you can help her dreams come true!
            Tap the notes as they enter the middle circles to play them, and create well known tunes.
            Unlock other guitars and outfits then open up a free-play mode to play any tune you like!`,
        gTags: [
            "Princess", "Frozen", "Music", "html5"
        ],
        gCharacters: [
            "Humans"
        ],
        urlName: "princessguitardreams",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 5,
        device: "Mobile",
        tech: "HTML5",
        gWidth: 800,
        gHeight: 480,
        Name: "Pet Salon Kitty Care",
        gamelink: "https://www.jmkit.com/duh/PetSalonKittyCare3/index.html",
        Thumb: "https://www.jmkit.com/images/gamethumbs/kittycare.jpg",
        gAbout: `You're back at work at the Pampered Paws Pet Salon, and today it's the cats in need of Kitty Care!
            Check the reception computer to see what kitty is up next, and take them through the salon to wash, dry and brush. Then give them some cool accessories for a finishing photo!`,
        gTags: [
            "Cats", "Salon", "Jobs", "html5"
        ],
        gCharacters: [
            "Jasper", "Lola"
        ],
        urlName: "petsalonkittycare",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 6,
        device: "Mobile",
        tech: "HTML5",
        gWidth: 800,
        gHeight: 480,
        Name: "Pocket Anime Maker",
        gamelink: "https://www.jmkit.com/duh/PocketAnimeMaker/index.html",
        Thumb: "https://www.jmkit.com/images/gamethumbs/duh_pocketanimemaker.jpg",
        gAbout: `Create your very own Chibi Anime Character!
            You can make a Girl, a Boy or even a Monster of your own design... Feed them to get their weight up, or excersise them to get their weight down, choose skin colour, expressions, outfits and much more!`,
        gTags: [
            "Chibi", "Customize", "html5"
        ],
        gCharacters: [
            "Humans"
        ],
        urlName: "pocketanimemaker",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 7,
        device: "Mobile",
        tech: "HTML5",
        gWidth: 800,
        gHeight: 480,
        Name: "Princess Claw Machine",
        gamelink: "https://www.jmkit.com/duh/Princess_ClawMachine/index.html",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/arcade_princessclawmachine.jpg",
        gAbout: `Hit the arcade and head strait to the mystery egg, claw machine game!
            You can win collectible stickers and figurines of your favorite Princesses, including special golden editions!
            You can even show off your favorite prizes and achievements on your own customizable shelves
            Will you be able to win all the prizes and collect all the achievements!?`,
        gTags: [
            "Arcade", "Princess", "Prizes", "html5"
        ],
        gCharacters: [
            "Humans"
        ],
        urlName: "princessclawmachine",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 8,
        device: "Mobile",
        tech: "HTML5",
        gWidth: 800,
        gHeight: 480,
        Name: "Aluminium Foil Ball Maker",
        gamelink: "https://www.jmkit.com/duh/AluminiumFoilBallMaker4/index.html",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/fun_aluminiumballmaker.jpg",
        gAbout: `This is a test of patience, and your clicking finger!! Will you take on the challenge of turning regular kitchen aluminium foil into a solid polished shiny smooth round ball!`,
        gTags: [
            "Arcade", "Patience", "Prizes", "html5"
        ],
        gCharacters: [
            ""
        ],
        urlName: "aluminiumfoilballmaker",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 9,
        device: "Mobile",
        tech: "HTML5",
        gWidth: 800,
        gHeight: 480,
        Name: "Ice Princess Doll House",
        gamelink: "https://www.jmkit.com/duh_l/IcePrincessDollHouse/index.html",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/dollhouse_iceprincesscastle.jpg",
        gAbout: `Join the Ice Princess in her Palace along with her family and friends, you can design the rooms, interact with and pick up objects and make the palace your own! Build a snowman, make friends with a bird, re-arange your furnature, it's all here`,
        gTags: [
            "Make-a-scene", "Princess", "Frozen", "html5"
        ],
        gCharacters: [
            "Humans"
        ],
        urlName: "iceprincessdollhouse",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 10,
        device: "Mobile",
        tech: "HTML5",
        gWidth: 800,
        gHeight: 480,
        Name: "Minion Maker",
        gamelink: "https://www.jmkit.com/duh/MinionMaker4/index.html",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/dressup_minionmaker.jpg",
        gAbout: `Here you can create your very own cute / cool or just downright crazy minion!
            Choose between the normal yellow style or crazed purple style, pick body shape, outfits, facial features, props and more to customise your minion to your dispicable hearts desire`,
        gTags: [
            "Dress-up", "Create", "Minions", "html5"
        ],
        gCharacters: [
            ""
        ],
        urlName: "minionmaker",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 11,
        device: "Mobile",
        tech: "HTML5",
        gWidth: 800,
        gHeight: 480,
        Name: "Pet Salon Doggy Days",
        gamelink: "https://www.jmkit.com/duh/PetSalon/index.html",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/fun_PetSalon.jpeg",
        gAbout: `You're working at the Pampered Paws Pet Salon, and today is Doggy Day!
            Check the reception computer to see what pup is up next, and take them through the salon to wash, dry and comb. Then give them some cool accessories for a finishing photo!`,
        gTags: [
            "Dress-up", "Dogs", "Job", "html5"
        ],
        gCharacters: [
            ""
        ],
        urlName: "petsalondoggydays",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 12,
        device: "Desktop",
        tech: "AS3",
        gWidth: 652,
        gHeight: 480,
        Name: "At The Beach",
        gamelink: "https://www.jmkit.com/classicgames/MakeAScene_Beach.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/mas_beach.jpeg",
        gAbout: `The temperature is rising and the JMKit crew head out for a day at the beach. Make-a-scene with Jinx, Minx and all their friends, chilling on the sand, splashing in the sea, even construct their own beach huts!`,
        gTags: [
            "Make-a-scene", "Beach", "Summer"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Bagle", "Pepper", "Pixie", "Missel", "Molly", "Tumble", "Chips", "Trott", "Flake", "Bleu", "Lil", "Debra", "Chloe", "Dex", "Boo"
        ],
        urlName: "atthebeach",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 13,
        device: "Desktop",
        tech: "AS3",
        gWidth: 652,
        gHeight: 480,
        Name: "At The Mall",
        gamelink: "https://www.jmkit.com/classicgames/MakeAScene_Mall.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/mas_mall.jpeg",
        gAbout: `It's time to hit the shops in the JMKit mall! Oh but before our cute and cool friends can go shopping, it's up to you to design and layout each store, are you up for the task?`,
        gTags: [
            "Make-a-scene", "Mall", "Shops",
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Bagle", "Pepper", "Pixie", "Missel", "Molly", "Tumble", "Chips", "Trott", "Flake", "Bleu", "Lil", "Debra", "Chloe", "Dex", "Boo"
        ],
        urlName: "atthemall",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 14,
        device: "Desktop",
        tech: "AS3",
        gWidth: 652,
        gHeight: 480,
        Name: "At The Circus",
        gamelink: "https://www.jmkit.com/classicgames/MakeAScene_Circus.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/mas_circus.jpeg",
        gAbout: `Roll up Roll up to the cutest show on earth!
            Join Jinx, Minx and the crew for fun and frolics in the big top! Click to drag items around, click the icons to start / stop the music and change the background items, and don't forget to try out each main characters different poses!`,
        gTags: [
            "Make-a-scene", "Circus", "Stage"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Bagle", "Pepper", "Pixie", "Missel", "Molly", "Chips", "Trott", "Flake", "Bleu", "Lil", "Chloe", "Boo"
        ],
        urlName: "atthecircus",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 15,
        device: "Desktop",
        tech: "AS2",
        gWidth: 720,
        gHeight: 480,
        Name: "Jinx's Xmas Adventure",
        gamelink: "https://www.jmkit.com/classicgames/Adventure_JinxsXmasAdventure.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/adventure_xmasadventure.jpeg",
        gAbout: `Jinx and Minx are decorating their house and getting ready to settle down for xmas holidays when a mystery letter arrives for Jinx!
            Find out what it says, where it'll lead him and help Jinx on his Xmas Quest!`,
        gTags: [
            "Adventure", "Christmas", "PointAndClick", "Winter"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Flake", "Bleu", "Bagle", "Pepper", "Pixie", "Sol"
        ],
        urlName: "jinx'sxmasadventure",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 16,
        device: "Desktop",
        tech: "AS2",
        gWidth: 652,
        gHeight: 480,
        Name: "Minx's Easter Adventure",
        gamelink: "https://www.jmkit.com/classicgames/Adventure_MinxsEasterAdventure.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/adventure_easteradventure.jpeg",
        gAbout: `Minx heads out to the park only to be greated by a puzzle hungry bunny offering her the chance to take part in an easter egg hunt!
            Complete mini-games and find all the eggs in this cute Easter themed adventure.`,
        gTags: [
            "Adventure", "Easter", "Mini-Games", "Spring"
        ],
        gCharacters: [
            "MinxBunny", "Sol"
        ],
        urlName: "minx'seasteradventure",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 17,
        device: "Desktop",
        tech: "AS2",
        gWidth: 717,
        gHeight: 480,
        Name: "Chips Balloon Ride",
        gamelink: "https://www.jmkit.com/classicgames/ChipsBalloonRide.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/adventure_chipsballoonride.jpeg",
        gAbout: `It's acron collecting season, and despite Chloe the giraffe being scared of the bees, she has a nifty plan to help chips collect them all! Swipe the acorns with your net and deposit them in the tree stumps while avoiding the pesky bees in levels on increasing dificulty!`,
        gTags: [
            "Adventure", "Arcade", "Woods", "Fall"
        ],
        gCharacters: [
            "Chips", "Chloe", "MinxBunny", "JinxBunny",
        ],
        urlName: "chipsballoonride",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 18,
        device: "Desktop",
        tech: "AS2",
        gWidth: 652,
        gHeight: 480,
        Name: "Christmas House Party",
        gamelink: "https://www.jmkit.com/classicgames/MakeAScene_WinterRoom.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/mas_xmasparty.jpeg",
        gAbout: `Decorate the house ready for all the winter festivities, decorate the tree, give presents.... ....Maybe even pull a cracker or two, it's up to you!`,
        gTags: [
            "Make-a-scene", "Xmas", "Winter", "House"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Pepper", "Pixie", "Bagle"
        ],
        urlName: "christmashouseparty",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 19,
        device: "Desktop",
        tech: "AS3",
        gWidth: 652,
        gHeight: 480,
        Name: "Christmas Mall",
        gamelink: "https://www.jmkit.com/classicgames/Xmas_MakeAScene_Mall.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/mas_xmasmall.jpeg",
        gAbout: `Decorate the house ready for all the winter festivities, decorate the tree, give presents.... ....Maybe even pull a cracker or two, it's up to you!`,
        gTags: [
            "Make-a-scene", "Xmas", "Winter", "Mall"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Bagle", "Pepper", "Pixie", "Missel", "Molly", "Chips", "Trott", "Flake", "Bleu", "Lil", "Chloe", "Boo"
        ],
        urlName: "christmasmall",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 20,
        device: "Desktop",
        tech: "AS3",
        gWidth: 652,
        gHeight: 480,
        Name: "In A Winter Park",
        gamelink: "https://www.jmkit.com/classicgames/Xmas_MakeAScene_WinterPark.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/mas_winterpark.jpeg",
        gAbout: `The snow is falling, the fields and hills of the park are glistening white, it's time to have fun! Take your favourite JMKit characters to a winter wonderland of your own creation!`,
        gTags: [
            "Make-a-scene", "Xmas", "Winter", "Park"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Bagle", "Pepper", "Pixie", "Missel", "Molly", "Chips", "Trott", "Flake", "Bleu", "Lil", "Chloe", "Boo"
        ],
        urlName: "inawinterpark",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 21,
        device: "Desktop",
        tech: "AS2",
        gWidth: 720,
        gHeight: 480,
        Name: "Flake and Bleu's World",
        gamelink: "https://www.jmkit.com/classicgames/World_FlakeAndBleu.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/mas_flakeandbleusworld.jpeg",
        gAbout: `Make-a-scene featuring the playful polar bears, Flake and Bleu. Building snowmen, sledging, snowball fights.. It's up to you!`,
        gTags: [
            "Make-a-scene", "Winter",
        ],
        gCharacters: [
            "Flake", "Bleu",
        ],
        urlName: "flakeandbleu'sworld",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 22,
        device: "Desktop",
        tech: "AS2",
        gWidth: 652,
        gHeight: 480,
        Name: "On A Desert Island",
        gamelink: "https://www.jmkit.com/classicgames/MakeAScene_DesertIsland.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/mas_desertisland.jpeg",
        gAbout: `Jinx and Minx have gotten themselves stranded on a desert island, It's up to you to find them a way to escape, explore or settle in to their new found island paradise!`,
        gTags: [
            "Make-a-scene", "Summer", "Beach"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny",
        ],
        urlName: "onadesertisland",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 23,
        device: "Desktop",
        tech: "AS2",
        gWidth: 652,
        gHeight: 480,
        Name: "In The Jungle",
        gamelink: "https://www.jmkit.com/classicgames/MakeAScene_Jungle.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/mas_jungle.jpeg",
        gAbout: `Jinx and Minx have crash landed in the jungle!
            Help them find their way around and meet all the local jungle wildlife.`,
        gTags: [
            "Make-a-scene", "Jungle",
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Chloe", "Debra"
        ],
        urlName: "inthejungle",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 24,
        device: "Desktop",
        tech: "AS2",
        gWidth: 652,
        gHeight: 480,
        Name: "At The North Pole",
        gamelink: "https://www.jmkit.com/classicgames/MakeAScene_NorthPole.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/mas_northpole.jpeg",
        gAbout: `Jinx and Minx join Flake and Bleu, and a new penguin friend Lil (who has gotten herself lost in the North pole) throw snowballs, build igloos and snowmen, go fishing oh and don't forget to check out the northern lights, it's quite a show`,
        gTags: [
            "Make-a-scene", "Winter",
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Lil", "Flake", "Bleu"
        ],
        urlName: "atthenorthpole",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 25,
        device: "Desktop",
        tech: "AS2",
        gWidth: 652,
        gHeight: 480,
        Name: "At The Rock Show",
        gamelink: "https://www.jmkit.com/classicgames/MakeAScene_RockShow.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/mas_rocktour.jpeg",
        gAbout: `And, it's time to rock out with Jinx Minx And featuring Pepper & Pixie, it's your job to decide who plays drums, who is on guitar.. do they need a keyboard player?! And on top of all that you are also the stage designer, fixing up lighting, smoke and fire machines.. so get to it!`,
        gTags: [
            "Make-a-scene", "Rock", "Music", "Stage"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Lil", "Flake", "Bleu"
        ],
        urlName: "attherockshow",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 26,
        device: "Desktop",
        tech: "AS3",
        gWidth: 652,
        gHeight: 480,
        Name: "Show Time",
        gamelink: "https://www.jmkit.com/classicgames/MakeAScene_ShowTime.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/mas_showtime.jpeg",
        gAbout: `It's Show Time for the JMKit crew... Who will be performing, who will be enjoying the show, what will the story be, it's all up to you!
            Drag and drop the characters and props as well as altering backdrops and scenery to create your own plays`,
        gTags: [
            "Make-a-scene", "Stage", "Costumes"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Bagle", "Pepper", "Pixie", "Missel", "Molly", "Tumble", "Chips", "Trott", "Flake", "Bleu", "Lil", "Debra", "Chloe", "Dex", "Boo"
        ],
        urlName: "showtime",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 27,
        device: "Desktop",
        tech: "AS3",
        gWidth: 652,
        gHeight: 480,
        Name: "At The Sweet Shop",
        gamelink: "https://www.jmkit.com/classicgames/MakeAScene_SweetShop.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/mas_sweetshop.jpeg",
        gAbout: `The JMKit characters all enjoy eating sweets, so what better than their very own sweet shop!
            Help them decorate and serve up their sweet treats!`,
        gTags: [
            "Make-a-scene", "Sweets", "Shops",
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Bagle", "Pepper", "Pixie", "Chips", "Trott", "Flake", "Bleu", "Chloe", "Boo"
        ],
        urlName: "atthesweetshop",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 28,
        device: "Desktop",
        tech: "AS3",
        gWidth: 652,
        gHeight: 480,
        Name: "At The Restaurant",
        gamelink: "https://www.jmkit.com/classicgames/MakeAScene_Restaurant.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/mas_restaurant.jpeg",
        gAbout: `A romantic meal for 2? How about for 17!
            You can place the tables to set the scene for a classic restaurant or clear them away, lower the glitter ball and have your own dance hall. Your scene, your occasion`,
        gTags: [
            "Make-a-scene", "Restaurant", "Love"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Bagle", "Pepper", "Pixie", "Missel", "Molly", "Tumble", "Chips", "Trott", "Flake", "Bleu", "Lil", "Debra", "Chloe", "Dex", "Boo"
        ],
        urlName: "attherestaurant",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 29,
        device: "Desktop",
        tech: "AS3",
        gWidth: 652,
        gHeight: 480,
        Name: "At The Water Park",
        gamelink: "https://www.jmkit.com/classicgames/MakeAScene_WaterPark.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/mas_waterpark.jpeg",
        gAbout: `The JMKit crew get wet and wild at the water park, what fun will they get up to with slides, rubber rings and inflatable dolphins!`,
        gTags: [
            "Make-a-scene", "Water Park", "Swimming"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Bagle", "Pepper", "Pixie", "Chips", "Trott", "Flake", "Bleu", "Chloe", "Boo"
        ],
        urlName: "atthewaterpark",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 30,
        device: "Desktop",
        tech: "AS3",
        gWidth: 652,
        gHeight: 480,
        Name: "At The Theme Park",
        gamelink: "https://www.jmkit.com/classicgames/MakeAScene_ThemePark.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/mas_themepark.jpeg",
        gAbout: `The JMKit characters have taken a trip to the Themepark, what are their fave rides and things to do? it's up to you!`,
        gTags: [
            "Make-a-scene", "Themepark",
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Bagle", "Pepper", "Pixie", "Chips", "Trott", "Flake", "Bleu", "Chloe", "Boo"
        ],
        urlName: "atthethemepark",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 31,
        device: "Desktop",
        tech: "AS2",
        gWidth: 720,
        gHeight: 480,
        Name: "Jinx & Minx's Tower Escape",
        gamelink: "https://www.jmkit.com/classicgames/Adventure_JinxMinxTowerEscape.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/adventure_towerescape.jpeg",
        gAbout: `It's Halloween, and the skeleton Jinx and Minx bunnies are trapped high in an abandoned tower! It's up to you to guide them through spooky corridors, haunted rooms and puzzles, collecting the keys and the candy to get the bunnies out and back together!`,
        gTags: [
            "Adventure", "PointAndClick", "Halloween", "Spooky"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Missel"
        ],
        urlName: "jinx&minx'stowerescape",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 32,
        device: "Desktop",
        tech: "AS2",
        gWidth: 720,
        gHeight: 480,
        Name: "Halloween Dress Up",
        gamelink: "https://www.jmkit.com/classicgames/DressUp_HalloweenPrincess.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/fun_halloweendressup.jpeg",
        gAbout: `Dress up our mysterious girl in lots of different outfit combinations, and set the scene to get her ready for a creepy night of trick or treating!`,
        gTags: [
            "DressUp", "Create", "Halloween", "Spooky", "Costumes"
        ],
        gCharacters: [
            "Pepper", "Pixie"
        ],
        urlName: "halloweendressup",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 33,
        device: "Desktop",
        tech: "AS3",
        gWidth: 652,
        gHeight: 480,
        Name: "Halloween Beach",
        gamelink: "https://www.jmkit.com/classicgames/Halloween_MakeAScene_Beach.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/mas_halloweenbeach.jpeg",
        gAbout: `While on holiday on their private island, the JMKit crew had a run-in with a zombie or two! Make-a-scene and tell a story with zombie Jinx, Minx and all their friends`,
        gTags: [
            "Make-a-scene", "Beach", "Halloween", "Spooky", "Zombies"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Bagle", "Pepper", "Pixie", "Missel", "Molly", "Tumble", "Chips", "Trott", "Flake", "Bleu", "Lil", "Debra", "Chloe", "Dex", "Boo"
        ],
        urlName: "halloweenbeach",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 34,
        device: "Desktop",
        tech: "AS3",
        gWidth: 652,
        gHeight: 480,
        Name: "Halloween Mall",
        gamelink: "https://www.jmkit.com/classicgames/Halloween_MakeAScene_Mall.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/mas_halloweenmall.jpeg",
        gAbout: `Thinking the mall would be a good place to hold out and escape the zombies wasn't such a good idea after all! Make-a-scene and tell a story with zombie Jinx, Minx and all their friends!`,
        gTags: [
            "Make-a-scene", "Mall", "Shops", "Halloween", "Spooky", "Zombies"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Bagle", "Pepper", "Pixie", "Missel", "Molly", "Tumble", "Chips", "Trott", "Flake", "Bleu", "Lil", "Debra", "Chloe", "Dex", "Boo"
        ],
        urlName: "halloweenmall",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 35,
        device: "Desktop",
        tech: "AS3",
        gWidth: 652,
        gHeight: 480,
        Name: "Halloween House Party",
        gamelink: "https://www.jmkit.com/classicgames/MakeAScene_HalloweenParty.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/mas_halloweenparty.jpeg",
        gAbout: `It's Halloween 2011 and your chance to throw a spooky Halloween bash for the JMKit crew! Decorate the house or go into the creepy night, just look out for ghosts and zombies!`,
        gTags: [
            "Make-a-scene", "Party", "Costumes", "Halloween", "Spooky", "Zombies"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Bagle", "Pepper", "Pixie", "Chips", "Trott", "Flake", "Bleu", "Chloe", "Boo"
        ],
        urlName: "halloweenhouseparty",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 36,
        device: "Desktop",
        tech: "AS2",
        gWidth: 800,
        gHeight: 480,
        Name: "Halloween Special",
        gamelink: "https://www.jmkit.com/classicgames/Create_ZombieCreator.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/mas_halloweenspecial.jpeg",
        gAbout: `Here is a 2 in 1 flash game. First you can create a spooky Halloween party scene featuring zombie Jinx and Minx, then create your very own creepy zombie girl!`,
        gTags: [
            "Maker", "Create", "Dress-up", "Make-a-scene", "Party", "Costumes", "Halloween", "Spooky", "Zombies"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny",
        ],
        urlName: "halloweenspecial",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 37,
        device: "Mobile",
        tech: "HTML5",
        gWidth: 800,
        gHeight: 480,
        Name: "Costume Dash Trapped In Halloween",
        gamelink: "https://www.jmkit.com/duh/TrappedInHalloween/index.html",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/arcade_trappedinhalloween.jpeg",
        gAbout: `Trick or treating was going well, right up until a door opened and you got sucked into a portal! Now you are trapped in Halloween forever, collecting candy and unlocking costumes! All you need to do is tap/click to jump your way through each level, avoiding holes, spiky vines and zombies!`,
        gTags: [
            "Arcade", "Runner", "Platformer", "Prizes", "Costumes", "Halloween", "Spooky", "Zombies"
        ],
        gCharacters: [
            "Humans",
        ],
        urlName: "costumedashtrappedinhalloween",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 38,
        device: "Mobile",
        tech: "HTML5",
        gWidth: 800,
        gHeight: 480,
        Name: "Halloween House Decoration",
        gamelink: "https://www.jmkit.com/duh/Halloween-House-Decorator/index.html",
        Thumb: "https://www.jmkit.com/images/gamethumbs/wide/makeascene_halloweendecoration.jpg",
        gAbout: `It's That time of the year again, visit a variety of welcoming abodes to transform into spooky halloween themed haunted houses. You can then also invite over some treak or treators to complete the scene!`,
        gTags: [
            "Create", "Make-a-scene", "Decorate", "Costumes", "Halloween", "Spooky", "Zombies"
        ],
        gCharacters: [
            "Humans"
        ],
        urlName: "halloweenhousedecoration",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 39,
        device: "Desktop",
        tech: "HTML5",
        gWidth: 800,
        gHeight: 480,
        Name: "Free Christmas Tree Decorator",
        gamelink: "https://www.jmkit.com/duh/FreeXmasTree/index.html",
        Thumb: "https://www.jmkit.com/images/gamethumbs/html5/fun_freexmastree.jpg",
        gAbout: `Pick and decorate your own free Christmas tree!
            Pick your tree and choose how you want to bring it down, and bring it into your home where you can choose the pot it stands in, spray it a colour of your choice then light and decorate it`,
        gTags: [
            "Create", "Decorate", "Christmas", "Winter"
        ],
        gCharacters: [
            ""
        ],
        urlName: "freechristmastreedecorator",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 40,
        device: "Desktop",
        tech: "AS3",
        gWidth: 652,
        gHeight: 480,
        Name: "Minx's Gingerbread Maker",
        gamelink: "https://www.jmkit.com/classicgames/Create_GingerbreadDesigner.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/fun_gingerbread.jpeg",
        gAbout: `Help Minx to design and decorate her freshly baked gingerbread any way you like!
            With Icing Swirls, Jelly Candy, Sprinkles and more, make the nommiest gingerbread man, woman or bunny you can!`,
        gTags: [
            "Create", "Decorate", "Christmas", "Winter", "Food"
        ],
        gCharacters: [
            "MinxBunny"
        ],
        urlName: "minx'sgingerbreadmaker",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 41,
        device: "Desktop",
        tech: "AS3",
        gWidth: 652,
        gHeight: 480,
        Name: "Minx's Cake Decoration",
        gamelink: "https://www.jmkit.com/classicgames/Create_CakeMaker.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/fun_cake.jpeg",
        gAbout: `Help Minx build, decorate and photograph her very own cake!`,
        gTags: [
            "Create", "Decorate", "Food"
        ],
        gCharacters: [
            "MinxBunny"
        ],
        urlName: "minx'scakedecoration",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 42,
        device: "Desktop",
        tech: "AS2",
        gWidth: 652,
        gHeight: 480,
        Name: "Glitter Globe Maker",
        gamelink: "https://www.jmkit.com/classicgames/Create_GlitterGlobeMaker.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/fun_glitterglobe.jpeg",
        gAbout: `Here you can make your very own JMKit Glitter Globe! Choose the shape and set the scene with a choice of characters, props and even the little bits you want to see floating around, then all it takes is a quick shake to set it all in motion!`,
        gTags: [
            "Create", "Decorate",
        ],
        gCharacters: [
            "MinxBunny", "JinxBunny", "Chloe", "Pepper", "Pixie"
        ],
        urlName: "glitterglobemaker",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 43,
        device: "Desktop",
        tech: "AS2",
        gWidth: 650,
        gHeight: 480,
        Name: "Snowman Decorator",
        gamelink: "https://www.jmkit.com/classicgames/Create_Snowman_Builder.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/fun_snowmanbuilder.jpeg",
        gAbout: `In one of the first ever JMKit games, you can help Flake build her very own snowman!`,
        gTags: [
            "Create", "Decorate",
        ],
        gCharacters: [
            "Flake"
        ],
        urlName: "snowmandecorator",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 44,
        device: "Desktop",
        tech: "AS2",
        gWidth: 720,
        gHeight: 480,
        Name: "Christmas Tree Decorator",
        gamelink: "https://www.jmkit.com/classicgames/Create_XmasTree.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/fun_xmastree.jpeg",
        gAbout: `Tis the season to deck the halls and trim the trees!
            Choose your helpers and decorate this cute tree.`,
        gTags: [
            "Create", "Decorate", "Christmas", "Winter"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Flake", "Bleu",
        ],
        urlName: "christmastreedecorator",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 45,
        device: "Mobile",
        tech: "HTML5",
        gWidth: 350,
        gHeight: 520,
        Name: "Character Creator Demo",
        gamelink: "https://www.jmkit.com/html5/charactercreatordemo/index.html",
        Thumb: "https://www.jmkit.com/images/gamethumbs/CharacterCreator.png",
        gAbout: ` The Character Creator demo lets you create your own human JMKit character! As it's still a demo there may be some bugs`,
        gTags: [
            "Create", "Dress-up",
        ],
        gCharacters: [
            "Humans"
        ],
        urlName: "charactercreatordemo",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 46,
        device: "Desktop",
        tech: "AS2",
        gWidth: 720,
        gHeight: 480,
        Name: "Jinx & Minx Spot The Difference",
        gamelink: "https://www.jmkit.com/classicgames/Play_SpotTheDifference.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/fun_spotthedifference.jpeg",
        gAbout: `Featuring images from Jinx and Minx's adventures at the park and beach, it's up to you to spot all the differences between the two images, and unlock the trophies. Then take on the marathon mode and complete all the stages in the fastest time to unlock more stages and complete your trophy collection!`,
        gTags: [
            "Puzzle", "Prizes"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny"
        ],
        urlName: "jinx&minxspotthedifference",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 47,
        device: "Desktop",
        tech: "AS2",
        gWidth: 652,
        gHeight: 480,
        Name: "Kitty Make Over",
        gamelink: "https://www.jmkit.com/classicgames/DressUp_KittyMakeover.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/fun_kittymakeover.jpg",
        gAbout: `It's time to give Pepper Pixie and Missel a make over!
            Change their fur style / colours and take them for a photo-shoot complete with props and backdrops!`,
        gTags: [
            "Dress-up", "Salon", "Stage", "Job"
        ],
        gCharacters: [
            "Pepper", "Pixie", "Missel"
        ],
        urlName: "kittymakeover",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    // {
    //     id: 48,
    //     device: "Desktop",
    //     tech: "Flash",
    //     gWidth: 800,
    //     gHeight: 480,
    //     Name: "Cat Finders",
    //     gamelink: "https://www.wjmkit.com/classicgames/CatFindersGame.swf",
    //     Thumb: "https://www.jmkit.com/images/gamethumbs/fun_Labsfinders.jpeg",
    //     gAbout: `Help the Kitties out and find all the items they are looking for in this game demo!`,
    //     gTags: [
    //         "Find", "Puzzle"
    //     ],
    //     gCharacters: [
    //         "Lola"
    //     ],
    //     urlName: "catfinders"
    // },
    {
        id: 49,
        device: "Desktop",
        tech: "AS2",
        gWidth: 652,
        gHeight: 480,
        Name: "Gift Giver",
        gamelink: "https://www.jmkit.com/classicgames/Fun_GiftGiver.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/fun_giftgiver.jpeg",
        gAbout: `Now you can treat, or just plain confuse your favourite JMKit characters by handing them a custom wrapped gift!
            Click the gift first, then customise the wrapping, then you can scroll through the characters and hand it over.. Try all the combinations to see their reactions!`,
        gTags: [
            "Decorate", "Fun"
        ],
        gCharacters: [
            "Trott", "Boo", "MinxBunny", "JinxBunny", "Pepper", "Pixie", "Bagle"
        ],
        urlName: "giftgiver",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 50,
        device: "Desktop",
        tech: "AS2",
        gWidth: 720,
        gHeight: 480,
        Name: "Metal Minx",
        gamelink: "https://www.jmkit.com/classicgames/Fun_MetalMinx.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/fun_metalminx.jpeg",
        gAbout: `Help Minx rock out with crazy guitars, and heavy riffs!
            Choose the style, colour and décor of her guitar, then take to the stage (or garage) and Jam out using your keyboard!`,
        gTags: [
            "Music", "Decorate", "Stage"
        ],
        gCharacters: [
            "MinxBunny",
        ],
        urlName: "metalminx",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 51,
        device: "Desktop",
        tech: "AS2",
        gWidth: 720,
        gHeight: 480,
        Name: "Jinx Drumming Bunny",
        gamelink: "https://www.jmkit.com/classicgames/Fun_JinxDrummingBunny.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/fun_drummingbunny.jpeg",
        gAbout: `Rock out with Jinx!
            You can click the drums and cymbals to play the drums like the superstar drumming bunny Jinx is!`,
        gTags: [
            "Music", "Fun"
        ],
        gCharacters: [
            "JinxBunny",
        ],
        urlName: "jinxdrummingbunny",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 52,
        device: "Desktop",
        tech: "AS2",
        gWidth: 720,
        gHeight: 480,
        Name: "Robot Builder",
        gamelink: "https://www.jmkit.com/classicgames/Create_RobotBuilder.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/fun_robotbuilder.jpeg",
        gAbout: `It's time to design your own cute girl robot!
            Click the arms, legs, body, head and ears to change all the parts, and drag and drop`,
        gTags: [
            "Create", "Decorate",
        ],
        gCharacters: [
        ],
        urlName: "robotbuilder",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 53,
        device: "Desktop",
        tech: "AS2",
        gWidth: 652,
        gHeight: 480,
        Name: "English Castle",
        gamelink: "https://www.jmkit.com/classicgames/DollHouse_Castle.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/dollhouse_castle.jpeg",
        gAbout: `Next stop in their time travelling journey is Elizabethan England, help them set up home in this fancy Castle Doll house!`,
        gTags: [
            "Doll House", "Make-a-scene", "Decorate", "Costumes"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Pepper", "Pixie", "Trott", "Boo"
        ],
        urlName: "englishcastle",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 54,
        device: "Desktop",
        tech: "AS2",
        gWidth: 652,
        gHeight: 480,
        Name: "Roman Colosseum",
        gamelink: "https://www.jmkit.com/classicgames/DollHouse_Colosseum.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/dollhouse_colosseum.jpeg",
        gAbout: `Jinx, Minx and a few of their friends have found them selves a time machine and a box of Dress-up costumes!
            Next stop in their time travelling journey is Elizabethan England, help them set up home in this fancy Castle Doll house!`,
        gTags: [
            "Doll House", "Make-a-scene", "Decorate", "Costumes"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Pepper", "Pixie", "Bagle", "Flake", "Bleu"
        ],
        urlName: "romancolosseum",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 55,
        device: "Desktop",
        tech: "AS2",
        gWidth: 652,
        gHeight: 480,
        Name: "Chinese Palace",
        gamelink: "https://www.jmkit.com/classicgames/DollHouse_Palace.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/dollhouse_palace.jpeg",
        gAbout: `Jinx, Minx and a few of their friends have found them selves a time machine and a box of Dress-up costumes! This time they find themselves in, a palace for tea drinking or a dōjō for Kung Fu training, it's up to you!`,
        gTags: [
            "Doll House", "Make-a-scene", "Decorate", "Costumes"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Flake", "Bleu", "Boo", "Trott"
        ],
        urlName: "chinesepalace",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 56,
        device: "Desktop",
        tech: "AS2",
        gWidth: 652,
        gHeight: 480,
        Name: "Egyptian Pyramid",
        gamelink: "https://www.jmkit.com/classicgames/DollHouse_Pyramid.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/dollhouse_pyramid.fw.jpeg",
        gAbout: `Jinx, Minx and a few of their friends have found them selves a time machine and a box of Dress-up costumes!
            This time they are in ancient Egypt, discovering all the mysteries of a Pyramid!`,
        gTags: [
            "Doll House", "Make-a-scene", "Decorate", "Costumes"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Flake", "Bleu", "Pepper", "Pixie", "Bagle"
        ],
        urlName: "egyptianpyramid",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 57,
        device: "Desktop",
        tech: "AS2",
        gWidth: 652,
        gHeight: 480,
        Name: "Mexican Temple",
        gamelink: "https://www.jmkit.com/classicgames/DollHouse_Temple.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/dollhouse_temple.fw.jpeg",
        gAbout: `Jinx, Minx and a few of their friends have found them selves a time machine and a box of Dress-up costumes!
            Next on their travels they came across this ancient Mayan Temple`,
        gTags: [
            "Doll House", "Make-a-scene", "Decorate", "Costumes"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Flake", "Bleu", "Pepper", "Pixie"
        ],
        urlName: "mexicantemple",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 58,
        device: "Mobile",
        tech: "HTML5",
        gWidth: 800,
        gHeight: 480,
        Name: "Coachella Scene Maker",
        gamelink: "https://www.dressupwho.net/html5/coachella-scene-maker/index.html",
        Thumb: "https://www.jmkit.com/images/gamethumbs/mas_coachella.jpeg",
        gAbout: `It's festival season and you're invited to Coachella!
            Set the scene for a fun festival full of famous tributes and packed with crowds ready to dance the night away, complete with lasers, fog machines and balloons!`,
        gTags: [
            "Make-a-scene", "Costumes", "Music"
        ],
        gCharacters: [
            "Humans"
        ],
        urlName: "coachellascenemaker",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 59,
        device: "Desktop",
        tech: "AS3",
        gWidth: 652,
        gHeight: 480,
        Name: "At The Pony Show",
        gamelink: "https://www.jmkit.com/classicgames/MakeAScene_PonyClub.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/mas_ponyclub.jpeg",
        gAbout: `The JMKit characters have joined the pony club, they can't cause Too much mischief, can they?!
            Look out for secret places, some special horses might be hiding out!`,
        gTags: [
            "Make-a-scene", "Summer"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Bagle", "Pepper", "Pixie", "Chips", "Trott", "Flake", "Bleu", "Chloe", "Boo"
        ],
        urlName: "attheponyshow",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 60,
        device: "Desktop",
        tech: "AS2",
        gWidth: 720,
        gHeight: 480,
        Name: "Pepper & Pixie's World",
        gamelink: "https://www.jmkit.com/classicgames/World_PepperAndPixie.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/mas_pepperpixieworld.jpeg",
        gAbout: `Make-a-scene featuring your favourite kitty pals, Pepper and Pixie!
            Whether they're playing in the alley, cozying up inside a house or frolicking in the field, it's up to you!`,
        gTags: [
            "Make-a-scene", "Cats"
        ],
        gCharacters: [
            "Pepper", "Pixie",
        ],
        urlName: "pepper&pixie'sworld",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 61,
        device: "Desktop",
        tech: "AS2",
        gWidth: 718,
        gHeight: 480,
        Name: "Chloe & Chips World",
        gamelink: "https://www.jmkit.com/classicgames/World_ChloeAndChips.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/mas_chloeandchipsworld.jpeg",
        gAbout: `It's a Make-a-scene game featuring the cutest squirrel / giraffe combo Chips and Chloe.
            You can change the scene, alternate between morning night and day, change their expressions and poses, and of course drag and drop to make the scene you want!`,
        gTags: [
            "Make-a-scene", "Woods", "Fall"
        ],
        gCharacters: [
            "Chips", "Chloe"
        ],
        urlName: "chloe&chipsworld",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 62,
        device: "Desktop",
        tech: "AS2",
        gWidth: 652,
        gHeight: 480,
        Name: "Jinx & Minx at the Beach",
        gamelink: "https://www.jmkit.com/classicgames/World_JinxAndMinxBeach.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/mas_jinxandminxatthebeach.jpeg",
        gAbout: `This time it's off to the beach with our favourite one eyed bunnies.
            Join Jinx and Minx and help them enjoy their beach trip, just watch out for the sneaky sea life!`,
        gTags: [
            "Make-a-scene", "Beach", "Summer"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny"
        ],
        urlName: "jinx&minxatthebeach",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 63,
        device: "Desktop",
        tech: "AS2",
        gWidth: 720,
        gHeight: 480,
        Name: "Jinx & Minx at the Park",
        gamelink: "https://www.jmkit.com/classicgames/World_JinxAndMinxPark.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/mas_jinxandminxatthepark.jpeg",
        gAbout: `Make-a-scene featuring everybody's favourite one-eyed bunnies, Jinx and Minx!
            You set the scene for their fun day at the park!`,
        gTags: [
            "Make-a-scene", "Park", "Summer"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny"
        ],
        urlName: "jinx&minxatthepark",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 64,
        device: "Desktop",
        tech: "AS3",
        gWidth: 652,
        gHeight: 480,
        Name: "Easter Park Egg Hunt",
        gamelink: "https://www.jmkit.com/classicgames/MakeAScene_EasterEggHunt.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/mas_easterpark.jpeg",
        gAbout: `It's Easter time again and time for the great Easter egg hunt! Make-a-scene with Jinx, Minx and all their friends.
            Take them hunting for eggs, exploring the park, and why not a picnic with their new found chocolate treats!`,
        gTags: [
            "Make-a-scene", "Park", "Spring", "Easter"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Bagle", "Pepper", "Pixie", "Missel", "Molly", "Tumble", "Chips", "Trott", "Flake", "Bleu", "Lil", "Debra", "Chloe", "Dex", "Boo"
        ],
        urlName: "easterparkegghunt",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 65,
        device: "Desktop",
        tech: "AS2",
        gWidth: 652,
        gHeight: 480,
        Name: "In The Deep Sea",
        gamelink: "https://www.jmkit.com/classicgames/MakeAScene_UnderWater.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/mas_underwater.jpeg",
        gAbout: `This time we're going deep underwater to explore sunken shipwrecks, treasure chests and many aquatic friends are there to keep Jinx, Minx, Pepper and Pixie busy!`,
        gTags: [
            "Make-a-scene", "Swimming"
        ],
        gCharacters: [
            "JinxBunny", "MinxBunny", "Bagle", "Pepper", "Pixie", "Missel", "Molly", "Tumble", "Chips", "Trott", "Flake", "Bleu", "Lil", "Debra", "Chloe", "Dex", "Boo"
        ],
        urlName: "inthedeepsea",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 66,
        device: "Desktop",
        tech: "AS2",
        gWidth: 720,
        gHeight: 480,
        Name: "Plushie Maker 1",
        gamelink: "https://www.jmkit.com/classicgames/Create_PlushieMaker.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/fun_plushiemaker1.jpeg",
        gAbout: `Make your own plushie doll, animal or monster, cute or creepy, its up to you!`,
        gTags: [
            "Maker", "Create"
        ],
        gCharacters: [

        ],
        urlName: "plushiemaker1",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 67,
        device: "Desktop",
        tech: "AS2",
        gWidth: 720,
        gHeight: 480,
        Name: "Plushie Maker 2",
        gamelink: "https://www.jmkit.com/classicgames/Create_PlushieMaker2.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/fun_plushiemaker2.jpeg",
        gAbout: `The second version of the Plushie Maker comes with more options and customisations to create even more cute. creepy or cool creations!`,
        gTags: [
            "Maker", "Create"
        ],
        gCharacters: [
        ],
        urlName: "plushiemaker2",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 68,
        device: "Desktop",
        tech: "AS2",
        gWidth: 720,
        gHeight: 480,
        Name: "Winter Dress Up",
        gamelink: "https://www.jmkit.com/classicgames/DressUp_Winter.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/winterdressup.jpg",
        gAbout: `It's cold outside, and our friend needs to dress accordingly - however you want!
            Dress to ski, dress to snowboard... dress as a polar bear.. whatever you think suits her best
            Oh and if you get bored, you can chuck snowballs at her!`,
        gTags: [
            "Dress-up", "Create", "Winter", "Costumes"
        ],
        gCharacters: [
            "Humans"
        ],
        urlName: "winterdressup",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
    {
        id: 69,
        device: "Desktop",
        tech: "AS2",
        gWidth: 720,
        gHeight: 480,
        Name: "Dress Up Minx",
        gamelink: "https://www.jmkit.com/classicgames/DressUp_MinxBunny.swf",
        Thumb: "https://www.jmkit.com/images/gamethumbs/minxdressup.jpg",
        gAbout: `Dress up Minx in a variety of outfits and costumes..
            Have fun and see if you can find any of the hidden objects ^_^`,
        gTags: [
            "Dress-up", "Costumes"
        ],
        gCharacters: [
            "MinxBunny"
        ],
        urlName: "dressupminx",
        prevURL: "https://www.jmkit.com/playsets/school/",
    },
]

export default AllGames;